import { useParams } from 'react-router-dom';

import { DashboardsPage } from '../dashboards/DashboardsPage';
import { GiftCardsErrorBanner } from '../gift-cards/GiftCardsErrorBanner';
import { GiftCardsLoadingState } from '../gift-cards/GiftCardsLoadingState';

import { maskedPassCode } from './gift-passes-model';
import { GiftPassDetailHeader } from './GiftPassDetailHeader';
import { GiftPassDetailWithActions } from './GiftPassDetailWithActions';
import { useGiftPassDetailState } from './use-gift-pass-detail-state';

import '../dashboards/dashboards.css';
import './gift-passes.css';

export default function GiftPassDetailPage() {
  const { id } = useParams<{ id: string }>();
  const s = useGiftPassDetailState(id ?? '');

  if (!s.detail) {
    return (
      <DashboardsPage header={<GiftPassDetailHeader />}>
        {s.loading ? (
          <GiftCardsLoadingState label="Loading this gift pass" />
        ) : (
          <GiftCardsErrorBanner message={s.error ?? 'That gift pass could not be loaded.'} />
        )}
      </DashboardsPage>
    );
  }

  return (
    <DashboardsPage
      header={<GiftPassDetailHeader code={maskedPassCode(s.detail.codeMasked)} />}
      stack={false}
    >
      <GiftPassDetailWithActions pass={s.detail} reload={s.reload} />
    </DashboardsPage>
  );
}
